module.exports = __webpack_public_path__ + "img/card_ip_stipulation85.f9dd3550.svg";